import * as ACTION from 'actions'

const initialState = {
	registerReplyEmail: null,
	registerCount: null
};

export function register(state=initialState, action) {
    if(action == null) return  state;

    switch (action.type) {
        case ACTION.FETCH_REGISTER_EMAIL:
            return {
              ...state,
              registerReplyEmail: action.register,
            }
        case ACTION.FETCH_REGISTER_COUNT:
            return {
              ...state,
              registerCount: action.register,
            }
        default:
            return state
    }
}
